import { render, staticRenderFns } from "./list_total.vue?vue&type=template&id=26e3b81a&scoped=true&"
import script from "./list_total.vue?vue&type=script&lang=js&"
export * from "./list_total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e3b81a",
  null
  
)

export default component.exports